import { ShipmentTrayDto } from "src/app/proxy/dto";
import { TrayShipmentStatus } from "../../proxy/enums";
import { GeneticMaterial } from "./generic-material";
import { TrayType } from "./tray-type";

export class ShipmentTray implements ShipmentTrayDto{
    id: string;
    tripId?: string;
    tripJourneyId?: string;
    depositId: number;
    depositName?: string;
    materialId: number;
    materialName?: string;
    trayTypeId: number;
    trayQuantity: number;
    receptionedTrayQuantity: number;
    material: GeneticMaterial;
    trayType: TrayType;
    trayTypeName?: string;
    plants: number;
    receptionedPlants: number;
    created?: string;
    status?: TrayShipmentStatus;
    resourceId: number;
    receiptNumber: number;
    plannedTrayQuantity: number;
    plannedPlants: number;
    replacementTypeId: number;

    constructor(dto: ShipmentTrayDto) {
      const { plantsPerTray, declaredVSReceptionedPlants, declaredVSReceptionedTrays, ...rest } = dto;
      Object.assign(this, rest);
    }

    get plantsPerTray(): number {
      return this.trayQuantity > 0 ? Math.round((this.plants / this.trayQuantity) * 10) / 10 : 0;
    }
  
    get declaredVSReceptionedPlants(): string {
      if (this.receptionedPlants > 0 && this.receptionedPlants !== this.plants) {
        return `${this.receptionedPlants}/${this.plants}`;
      }
      return this.plants.toString();
    }
  
    get declaredVSReceptionedTrays(): string {
      if (this.receptionedTrayQuantity > 0 && this.receptionedTrayQuantity !== this.trayQuantity) {
        return `${this.receptionedTrayQuantity}/${this.trayQuantity}`;
      }
      return this.trayQuantity.toString();
    }
  }